module.exports = __webpack_public_path__ + "/login_ui/img/jp-8df20b888f2bf00c5a0a9b3001b8b72d.svg";